import { computed, inject } from '@angular/core';
import {
  ObjectSearchGlobalStore,
  type ObjectSearchSuggestion,
} from '@bizzdesign/data-access-search';
import {
  getState,
  signalStore,
  withComputed,
  withMethods,
} from '@ngrx/signals';

export const AdvancedFilterRelationshipComponentStore = signalStore(
  withComputed(() => {
    const objectSearchGlobalStore = inject(ObjectSearchGlobalStore);

    return {
      objectSearchStoreProperties: computed(() =>
        getState(objectSearchGlobalStore),
      ),
    };
  }),
  withMethods(
    (_store, objectSearchGlobalStore = inject(ObjectSearchGlobalStore)) => ({
      updateSearchTerm: (term: string): void => {
        objectSearchGlobalStore.updateReferenceType(undefined);
        objectSearchGlobalStore.updateSearchTerm(term);
      },
      updateSearchSuggestionsLoading: (loading: boolean): void => {
        objectSearchGlobalStore.updateSearchSuggestionsLoading(loading);
      },
      updateSearchSuggestions: (
        searchSuggestions: ObjectSearchSuggestion[],
      ): void => {
        objectSearchGlobalStore.updateSearchSuggestions(searchSuggestions);
      },
    }),
  ),
);

export type AdvancedFilterRelationshipComponentStore = InstanceType<
  typeof AdvancedFilterRelationshipComponentStore
>;
